import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-primary-DEFAULT text-primary-DEFAULT py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-primary-DEFAULT">Contact Information</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone size={18} className="mt-1 flex-shrink-0" />
                <span>(402) 680-6757</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>17310 Wright St, Ste 100, Omaha, NE 68130</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock size={18} className="mt-1 flex-shrink-0" />
                <span>Monday - Friday: 7:00 AM - 7:00 PM</span>
              </li>
            </ul>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-primary-DEFAULT">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-primary-dark transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-dark transition-colors">
                  About Me
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-dark transition-colors">
                  Insurance Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary-dark transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href="https://agent-privacy.com/scameron"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary-dark transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
          
          {/* Service Areas */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-primary-DEFAULT">Service Areas</h3>
            <p className="mb-3">Serving Omaha, NE and surrounding communities.</p>
            <p className="mb-3">Licensed in AR, CA, and more.</p>
            <Link 
              to="/contact" 
              className="inline-block px-6 py-2 bg-primary-dark text-white rounded-md hover:bg-opacity-90 transition-colors mt-2"
            >
              Get a Free Quote
            </Link>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-sm text-center text-primary-DEFAULT">
          <p>© {currentYear} Scott Cameron. All rights reserved.</p>
          <p className="mt-2 text-xs text-primary-DEFAULT">
            Scott Cameron operates as an independent insurance agent and is not affiliated with the Health Insurance Marketplace® website.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 